<app-blocker [blocked]="showPageLoadingIndicator"></app-blocker>

<p-confirmDialog key="defaultConfirmWithCheckbox" #cd>
  <ng-template #footer>
    <confirmdialog-checkbox-footer [confirmDialog]="cd"></confirmdialog-checkbox-footer>
  </ng-template>
</p-confirmDialog>

@if (showMasthead) {
  <app-masthead class="bg-white"></app-masthead>
}

<main class="flex grow flex-column">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</main>

@if (showFooter) {
  <footer class="py-4">
    <div class="px-8">
      <p class="m-0 text-xs text-grey">
        <span class="float-right ml-4">{{ appVersion }}</span>
      </p>
    </div>
  </footer>
}

<p-scrollTop
  [threshold]="300"
  icon="icon-chevronUp-outline relative -top-1px p-3 text-sm text-grey-medium hover:text-white"
  styleClass="mb-2 mr-4 bg-white shadow-md rounded-full hover:bg-orange-default"
></p-scrollTop>

<p-toast position="top-center" key="global-error-slot" [style]="{width: '480px', marginLeft: '-240px'}" [hideTransformOptions]="'translateY(-30%)'">
  <ng-template #message let-message>
    <div class="flex">
      <h4 class="pr-8 mb-4 font-bold mt-2px">{{message.summary}}</h4>
      <div class="flex-1">
        @if (message.data?.items) {
          <ul>
            @for (item of message.data.items; track item) {
              <li class="relative pl-6 mb-2">
                <span class="absolute icon-alert-fill -left-2px -mt-1px"></span>
                <span [innerHTML]="item | safe: 'html'"></span>
              </li>
            }
          </ul>
        }
        @if (message.detail) {
          <p class="break-all" [innerHTML]="message.detail | safe: 'html'"></p>
        }
        @if (message.id) {
          <p class="relative pt-2 mt-2 border-t border-grey-dark/25 -bottom-1 top-1">ID: {{ message.id }}</p>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
